import urls from '../api_urls/qrCode'
import { _post } from '@/axios/request'

// 保存二维码
export function saveCode (params) {
  return _post(urls.SAVE_QRCODE, params)
}

// 编辑二维码
export function editCode (params) {
  return _post(urls.EDIT_QRCODE, params)
}

// 获取二维码列表
export function getCodeList (params) {
  return _post(urls.GET_CODE_LIST, params)
}

// 删除二维码
export function deleteCode (params) {
  return _post(urls.DELETE_QRCODE, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/qrCode.js